import "reflect-metadata";
class NodeTypeByEvent {
  eventName?: string;
  sortOrder?: number;
  constructor(readonly nodeTypeCode: string, readonly eventCode: string) {

  }
}

export default NodeTypeByEvent;